<template>
  <div class="pb-100">
    <div class="container">
      <div class="section-title">
        <span class="top-title">GET IN TOUCH</span>
        <h2>
          Your Gateway to Excellence: Contact Us and Unlock a World of
          Possibilities
        </h2>
      </div>

      <ul class="careers-list ps-0 mb-0 list-unstyled">
        <li
          class="careers-single-item d-md-flex align-items-center justify-content-between"
        >
          <div class="careers-content">
            <h3>Online Marketing Manager</h3>
            <ul
              class="ps-0 mb-0 list-unstyled d-sm-flex mt-3 mt-md-0 careers-info"
            >
              <li class="d-flex align-items-center mb-3 mb-sm-0">
                <div class="icon">
                  <img src="../../assets/images/location.png" alt="location" />
                </div>
                <span class="ms-2">Texas</span>
              </li>
              <li class="d-flex align-items-center mb-3 mb-sm-0">
                <div class="icon">
                  <img src="../../assets/images/bag.png" alt="bag" />
                </div>
                <span class="ms-2">Full Time</span>
              </li>
              <li class="d-flex align-items-center">
                <div class="icon">
                  <img src="../../assets/images/calendar.png" alt="calendar" />
                </div>
                <span class="ms-2">July 29, 2024</span>
              </li>
            </ul>
          </div>
          <router-link to="/career-details" class="default-btn mt-3 mt-md-0">
            VIEW DETAILS
            <img
              src="../../assets/images/icon-right-black.png"
              alt="icon-right-black"
            />
          </router-link>
        </li>
        <li
          class="careers-single-item d-md-flex align-items-center justify-content-between"
        >
          <div class="careers-content">
            <h3>Social Media Content Manager</h3>
            <ul
              class="ps-0 mb-0 list-unstyled d-sm-flex mt-3 mt-md-0 careers-info"
            >
              <li class="d-flex align-items-center mb-3 mb-sm-0">
                <div class="icon">
                  <img src="../../assets/images/location.png" alt="location" />
                </div>
                <span class="ms-2">New York</span>
              </li>
              <li class="d-flex align-items-center mb-3 mb-sm-0">
                <div class="icon">
                  <img src="../../assets/images/bag.png" alt="bag" />
                </div>
                <span class="ms-2">Full Time</span>
              </li>
              <li class="d-flex align-items-center">
                <div class="icon">
                  <img src="../../assets/images/calendar.png" alt="calendar" />
                </div>
                <span class="ms-2">July 28, 2024</span>
              </li>
            </ul>
          </div>
          <router-link to="/career-details" class="default-btn mt-3 mt-md-0">
            VIEW DETAILS
            <img
              src="../../assets/images/icon-right-black.png"
              alt="icon-right-black"
            />
          </router-link>
        </li>
        <li
          class="careers-single-item d-md-flex align-items-center justify-content-between"
        >
          <div class="careers-content">
            <h3>Software Engineer, Identity Platform (React/Java)</h3>
            <ul
              class="ps-0 mb-0 list-unstyled d-sm-flex mt-3 mt-md-0 careers-info"
            >
              <li class="d-flex align-items-center mb-3 mb-sm-0">
                <div class="icon">
                  <img src="../../assets/images/location.png" alt="location" />
                </div>
                <span class="ms-2">Boston, MA</span>
              </li>
              <li class="d-flex align-items-center mb-3 mb-sm-0">
                <div class="icon">
                  <img src="../../assets/images/bag.png" alt="bag" />
                </div>
                <span class="ms-2">Full Time</span>
              </li>
              <li class="d-flex align-items-center">
                <div class="icon">
                  <img src="../../assets/images/calendar.png" alt="calendar" />
                </div>
                <span class="ms-2">July 27, 2024</span>
              </li>
            </ul>
          </div>
          <router-link to="/career-details" class="default-btn mt-3 mt-md-0">
            VIEW DETAILS
            <img
              src="../../assets/images/icon-right-black.png"
              alt="icon-right-black"
            />
          </router-link>
        </li>
        <li
          class="careers-single-item d-md-flex align-items-center justify-content-between"
        >
          <div class="careers-content">
            <h3>WordPress Developer</h3>
            <ul
              class="ps-0 mb-0 list-unstyled d-sm-flex mt-3 mt-md-0 careers-info"
            >
              <li class="d-flex align-items-center mb-3 mb-sm-0">
                <div class="icon">
                  <img src="../../assets/images/location.png" alt="location" />
                </div>
                <span class="ms-2">Texas</span>
              </li>
              <li class="d-flex align-items-center mb-3 mb-sm-0">
                <div class="icon">
                  <img src="../../assets/images/bag.png" alt="bag" />
                </div>
                <span class="ms-2">Full Time</span>
              </li>
              <li class="d-flex align-items-center">
                <div class="icon">
                  <img src="../../assets/images/calendar.png" alt="calendar" />
                </div>
                <span class="ms-2">July 26, 2024</span>
              </li>
            </ul>
          </div>
          <router-link to="/career-details" class="default-btn mt-3 mt-md-0">
            VIEW DETAILS
            <img
              src="../../assets/images/icon-right-black.png"
              alt="icon-right-black"
            />
          </router-link>
        </li>
        <li
          class="careers-single-item d-md-flex align-items-center justify-content-between"
        >
          <div class="careers-content">
            <h3>SEO / Internet Marketer</h3>
            <ul
              class="ps-0 mb-0 list-unstyled d-sm-flex mt-3 mt-md-0 careers-info"
            >
              <li class="d-flex align-items-center mb-3 mb-sm-0">
                <div class="icon">
                  <img src="../../assets/images/location.png" alt="location" />
                </div>
                <span class="ms-2">Texas</span>
              </li>
              <li class="d-flex align-items-center mb-3 mb-sm-0">
                <div class="icon">
                  <img src="../../assets/images/bag.png" alt="bag" />
                </div>
                <span class="ms-2">Full Time</span>
              </li>
              <li class="d-flex align-items-center">
                <div class="icon">
                  <img src="../../assets/images/calendar.png" alt="calendar" />
                </div>
                <span class="ms-2">July 25, 2024</span>
              </li>
            </ul>
          </div>
          <router-link to="/career-details" class="default-btn mt-3 mt-md-0">
            VIEW DETAILS
            <img
              src="../../assets/images/icon-right-black.png"
              alt="icon-right-black"
            />
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "CareersContent",
};
</script>

<style lang="scss" scoped>
.careers-list {
  .careers-single-item {
    border-radius: 20px;
    border: 1px solid #e3e3e3;
    background-color: var(--whiteColor);
    padding: 35px 50px;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }

    .careers-content {
      h3 {
        font-size: 24px;
        margin-bottom: 15px;
      }
      .careers-info {
        li {
          margin-right: 25px;

          .icon {
            width: 32px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border-radius: 50px;
            background-color: #e3e3e3;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .default-btn {
      background-color: transparent;
      color: var(--headingColor);
      border: 1px solid var(--headingColor);
      &:hover {
        background-color: var(--mainColor);
        border-color: var(--mainColor);
        color: var(--whiteColor);
        img {
          filter: invert(1);
        }
      }
    }
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .careers-list {
    .careers-single-item {
      padding: 20px;
      .careers-content {
        h3 {
          font-size: 20px;
        }
      }
    }
  }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .careers-list {
    .careers-single-item {
      padding: 30px;
      .careers-content {
        h3 {
          font-size: 20px;
        }
      }
    }
  }
}
</style>